// extracted by mini-css-extract-plugin
export default {"wrapper":"_5908bfd3","header":"_722393df","learnMore":"_9694f541","benefits":"_3a435e04","benefitColumn":"_315d2d61"};